import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import TextField from '@clds/text-field';
import { Button } from '@clds/button';
import { ModalLayout } from '@clds/modal';
import { Label } from '@clds/form';

export const InputSection = styled.div`
  display: flex;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
`;

export const StyledModalLayout = styled(ModalLayout)`
  width: 390px;
`;

export const TipsSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${globalTheme.spacing.lg};
`;

export const TipsSectionTitle = styled.div`
  margin-bottom: ${globalTheme.spacing.xxs};
`;

export const Tip = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: ${globalTheme.spacing.xxs};
  font-weight: normal;
  &:last-of-type {
    margin-bottom: 0;
  }
  svg {
    margin-right: ${globalTheme.spacing.xxs};
  }
`;

export const ButtonsSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  margin-left: ${globalTheme.spacing.sm};
`;

export const StyledLabel = styled(Label)`
  font-weight: normal;
`;

export const NamePrefix = styled.div`
  padding: ${globalTheme.spacing.xs} 0;
  margin-right: ${globalTheme.spacing.xxs};
  font-weight: normal;
`;
